import type {SiteLite} from '@/multisite/types'
import {normalizePathname} from '@/lib/routing'
import {specialPageBaseSegment, specialPagePath} from '@/lib/specialPages'

const normalizeComparablePath = (value: string) =>
  normalizePathname(value, {allowUrl: true}).replace(/\/+$/, '') || '/'

export const campaignDealerWidgetConfig = (campaignSlug?: string | null) => {
  const normalizedCampaignSlug = campaignSlug?.trim() || undefined

  return {
    type: 'findDealerDrawer' as const,
    campaignSlug: normalizedCampaignSlug,
  }
}

export const isDealerFinderAction = (href: string | null, site?: SiteLite | null) => {
  if (!href || !site) return false

  const buttonPath = normalizeComparablePath(href)
  const dealerPath = normalizeComparablePath(specialPagePath(site, 'dealers'))
  const dealerBasePath = normalizeComparablePath(specialPageBaseSegment(site, 'dealers'))
  const defaultDealerPath = normalizeComparablePath('/dealers')

  return (
    buttonPath === dealerPath || buttonPath === dealerBasePath || buttonPath === defaultDealerPath
  )
}
